import { useInterventionTypesQuery } from "../../generated/graphql"
import useConcession from "../../hooks/useConcession"
import { FilterProps } from "../../types/types"
import { SelectFilter } from "../SelectFilter/SelectFilter"

export default function InterventionTypeFilter(props: FilterProps) {
    const { value, onChange } = props
    const query = useInterventionTypesQuery
    const concession = useConcession()

    return <SelectFilter
        value={value}
        onChange={onChange}
        query={query}
        multiple={true}
        field="interventionType"
        label="Tipo Trabalho"
        filter={{
            concession: {
                id: {
                    eq: concession?.id
                }
            }
        }}
        width={170}
        paging={{ limit: 999 }}
    />
}
